import { Flex, FlexProps } from '@chakra-ui/react';
import React from 'react';

export const MenuOpenerButton: React.FC<
  { children: React.ReactNode } & FlexProps
> = ({ children, ...props }) => {
  return (
    <Flex
      p="14px"
      borderRadius="lg"
      borderWidth="1px"
      color="content.label"
      fontSize="md"
      fontFamily="marketingPage"
      fontWeight="normal"
      borderColor="surface.border"
      bg="surface.sidebarMuted"
      {...props}>
      {children}
    </Flex>
  );
};
